import React, { createContext, useContext } from 'react';
import useRecordsUpdater from '../hooks/useRecordsUpdater';

const RecordsUpdaterContext = createContext();

export const useRecordsUpdaterContext = () => useContext(RecordsUpdaterContext);

export const RecordsUpdaterProvider = ({ children }) => {
  const recordsUpdater = useRecordsUpdater();
  return (
    <RecordsUpdaterContext.Provider value={recordsUpdater}>
      {children}
    </RecordsUpdaterContext.Provider>
  );
};
